// Slot floors of the two-pane workspace (the slot model, #359–#361), and the
// one geometry rule #432 adds on top of them.
//
// CHAT_MIN_WIDTH is the width every #243 containment contract is written
// against; PANEL_MIN_WIDTH is the narrowest a panel's own chrome (the Kanban
// single-row header, #112/#222) can survive. DIVIDER_WIDTH mirrors the
// SplitDivider's `w-[14px]`. See the sizing comment on the occupant wrapper in
// MainOfficeView.

export const CHAT_MIN_WIDTH = 240;
export const PANEL_MIN_WIDTH = 380;
export const DIVIDER_WIDTH = 14;
// The conversation column (`w-[300px]` in ConversationSidebar) plus the 14px
// `shell:gap` beside it. #432: once the desktop shell runs below 1280px (tablets
// in landscape), the column is the first thing to give way — see
// `conversationColumnFits` below.
export const CONVERSATION_COLUMN_SPACE = 300 + 14;

/**
 * Does the conversation column fit beside what the chat occupant needs (#432)?
 * `width` is this view's own width (everything right of the Features Sidebar).
 * Unknown width (first paint) counts as "fits", so nothing flickers at desktop
 * sizes. At the shell's old 1280px minimum the view is 988px wide, which leaves
 * the chat + a panel 674px ≥ 634 — so at ≥1280px this is ALWAYS true and the
 * desktop layout is unchanged.
 */
export function conversationColumnFits(width, hasFeatureBeside) {
    if (!width) return true;
    const chatArea = hasFeatureBeside ? CHAT_MIN_WIDTH + DIVIDER_WIDTH + PANEL_MIN_WIDTH : CHAT_MIN_WIDTH;
    return width - CONVERSATION_COLUMN_SPACE >= chatArea;
}

// The shell chrome left of the view: the Features Sidebar, the frame's 14px
// padding on both sides and the 14px gap after the sidebar.
export const RAIL_WIDTH = 250;
export const RAIL_COMPACT_WIDTH = 72;
export const FRAME_CHROME = 14 + 14 + 14;
// Two features side by side (#361): both at their floor plus the divider.
export const TWO_FEATURES_MIN_VIEW = PANEL_MIN_WIDTH + DIVIDER_WIDTH + PANEL_MIN_WIDTH;

/**
 * Must the Features Sidebar go icon-only (#432)? Only when two FEATURES are side
 * by side (the chat closed, nothing expanded) and the full 250px sidebar would
 * leave them less than their 774px of floors — i.e. a viewport of 1024–1065px.
 * Folding the conversation column is the first resort and covers chat + panel;
 * this is the second, and the narrowest one that works: at ≥1066px (and so at
 * every desktop width) it is always false.
 */
export function railMustCompact(viewportWidth, { featureCount = 0, chatOpen = true, expanded = false } = {}) {
    if (!viewportWidth || chatOpen || expanded || featureCount < 2) return false;
    return viewportWidth - RAIL_WIDTH - FRAME_CHROME < TWO_FEATURES_MIN_VIEW;
}
